import { render, staticRenderFns } from "./TraxUiSelect.vue?vue&type=template&id=37eb24ee&scoped=true"
import script from "./TraxUiSelect.vue?vue&type=script&lang=js"
export * from "./TraxUiSelect.vue?vue&type=script&lang=js"
import style0 from "./TraxUiSelect.vue?vue&type=style&index=0&id=37eb24ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eb24ee",
  null
  
)

export default component.exports